/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import { LoaderMini } from '~/components/Loaders';
import { CardText, Col, Container, Row } from 'reactstrap';
import { MdArrowForwardIos, MdArrowBackIosNew  } from "react-icons/md";
import { ButtonNextPrev, InputSelect, InputYear, TableAgenda } from './styles';



/*
	dayNumber: número do dia selecionado.
	setDay: função para definir o dia selecionado.
	month: mês atual (0 a 11).
	setMonth: função para definir o mês selecionado.
	year: ano atual.
	setYear: função para definir o ano selecionado.
	showAgenda: booleano para controlar a exibição da agenda (padrão true).
	setParams: função para definir os parâmetros de data inicial e final no formato YYYY-MM-DD.
		{
			dateInit: 'YYYY-MM-DD',
			dateEnd: 'YYYY-MM-DD',
		}
	disabledAll: booleano para desabilitar todos os controles (meses, dias, ano).
	tableData: objeto contendo dados para cada dia do mês, no formato:
		{
			1: ["quadro VERDE do dia 1", "quadro AZUL do dia 1", "quadro VERMELHO do dia 1"],
			24: ["quadro VERDE do dia 24", "quadro AZUL do dia 24"]
		}
*/

function Agenda(props) {
	const today = new Date();
	const currentYear = today.getFullYear();
	const currentMonth = today.getMonth();
	const currentDate = today.getDate();

  	const {isMobile = false, typeData = "money", dayNumber, month, year, setDay, setYear, setMonth, showAgenda = true, setParams, disabledAll, tableData} = props;

  	const [daysInMonth, setDaysInMonth] = useState(0);
  	const [firstDayOfWeek, setFirstDayOfWeek] = useState(0);
	const [yearPlaceholder, setYearPlaceholder] = useState(0);

	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);

	const monthList = [
		{ name: "JANEIRO", value: 0 },
		{ name: "FEVEREIRO", value: 1 },
		{ name: "MARÇO", value: 2 },
		{ name: "ABRIL", value: 3 },
		{ name: "MAIO", value: 4 },
		{ name: "JUNHO", value: 5 },
		{ name: "JULHO", value: 6 },
		{ name: "AGOSTO", value: 7 },
		{ name: "SETEMBRO", value: 8 },
		{ name: "OUTUBRO", value: 9 },
		{ name: "NOVEMBRO", value: 10 },
		{ name: "DEZEMBRO", value: 11 }
	];

	const [dayList, setDayList] = useState([]);

	useEffect(() => {
		setDay(currentDate)
		setMonth(currentMonth)
		setYear(currentYear)
		setYearPlaceholder(new Date(currentYear, 1,1))
	}, [])

	useEffect(() => {
		getDaysInMonth(year, month);
		setFirstDayOfWeek(new Date(year, month , 1).getDay());
	}, [month, year])

	function getDaysInMonth(yearT, monthT) {
		const monthFormated = monthT + 1;
		if (monthT === 1) {
			if ((yearT % 4 === 0 && yearT % 100 !== 0) || yearT % 400 === 0) {
			getListDay(29)
			setParams({
				dateInit: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-01`,
				dateEnd: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-29`,
				})
			return setDaysInMonth(29);
			} else {
			getListDay(28)
			setParams({
				dateInit: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-01`,
				dateEnd: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-28`,
				})
			return setDaysInMonth(28);
			}
			} else {
			setParams({
				dateInit: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-01`,
				dateEnd: `${yearT}-${monthFormated <= 9 ? `0${monthFormated}` : monthFormated }-${new Date(yearT, monthT + 1, 0).getDate()}`,
				})
			getListDay(new Date(yearT, monthT + 1, 0).getDate())
			return setDaysInMonth(new Date(yearT, monthT + 1, 0).getDate());
		}
	}

	function getListDay(lastDay){
		const list = []
		for (let i = 0; i <= lastDay; i++){
			if (i > 0){
				list.push({name: `${i}`, value: i})
			}
		}
		setDayList(list)
	}

	function handleChangeDay(day) {
		setDay(day)
	}

	function renderDays() {
		const days = [];
		let day = 1;
		let week = [];

		for (let i = 0; i < firstDayOfWeek; i++) {
			week.push(
				<td key={`empty-${i}`} className="empty">
					<div className="empty-area">
						<span>.</span>
						<span>.</span>
						<span>.</span>
						<span>.</span>
					</div>
				</td>);
		}

		while (day <= daysInMonth) {
			const classNames = ['day'];
			if (year === currentYear && month === currentMonth && day === currentDate) {
				classNames.push('today');
			}
			week.push(
				<td key={day} onClick={handleChangeDay.bind(null, day)} className={`${classNames.join(' ')}`}>
					<div className="box-day-area">
					{disabledAll ?
						<LoaderMini />
					:
						<div className={`${day === dayNumber ? 'active-day' : 'normal-day'}`}>
							<span>{day < 10 ? `0${day}`: day}</span>
							<p className="box-first">{tableData[day] && tableData[day].blue ? formatData(tableData[day].blue) : ""}</p>
							<p className="box-second">{tableData[day] && tableData[day].green ? formatData(tableData[day].green) : ""}</p>
							<p className="box-third">{tableData[day] && tableData[day].red ? formatData(tableData[day].red) : ""}</p>
						</div>
					}

					</div>
				</td>
			);

			if (new Date(year, month, day).getDay() === 6) {
				days.push(<tr className="week" key={`week-${days.length}`}>{week}</tr>);
				week = [];
			}
			day++;
		}


		if (week.length > 0) {
			for (let i = week.length; i < 7; i++) {
				week.push(<td key={`empty-after-${i}`} className="empty"><div className="empty-area">...</div></td>);
			}
		days.push(<tr className="week" key={`week-${days.length}`}>{week}</tr>);
		}

		return days;
	}

	function formatData(data){
		if(typeData === "money"){
			if(isMobile){
				return "R$";
			}
			const newData = data.toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});

			return newData;
		}else{
			return data;
		}
	}

	const handleYearChange = value => {
		setYearPlaceholder(value)
		const data = new Date(value).getFullYear();
		setYear(data)
	};

  return (
	<Container fluid style={{ padding: 18}}>
		<b>AGENDA</b>
		<Row style={{ padding: 10, paddingTop: 4}}>
			<Col xs="2" style={{ padding: 0, margin: 3 }}>
				<InputSelect
					disabled={disabledAll}
					value={dayNumber}
					type="select"
					onChange={(event) => setDay(parseInt(event.target.value, 10))}
				>
					{dayList.length > 0 && dayList.map((item, index) => {
						return (
							<option key={index} value={item.value}>
								{item.name}
							</option>
						);
					})}
				</InputSelect>
			</Col>
			<Col xs="1" style={{ padding: 0, margin: 3 }}>
				<ButtonNextPrev disabled={month === 0 || disabledAll} onClick={() => setMonth(month-1)}><MdArrowBackIosNew /></ButtonNextPrev>
			</Col>

			<Col
				 style={{ padding: 0, margin: 3 }}
				>
				<InputSelect
					disabled={disabledAll}
					id="exampleSelect"
					name="select"
					type="select"
					onChange={(event) => setMonth(parseInt(event.target.value, 10))}
					value={month}
				>
					{monthList.length > 0 && monthList.map((item, index) => {
						return (
							<option key={index} value={item.value}>
								{item.name}
							</option>
						);
					})}
				</InputSelect>
			</Col>

			<Col xs="1" style={{ padding: 0, margin: 3 }}>
				<ButtonNextPrev disabled={month === 11 || disabledAll} onClick={() => setMonth(month+1)}><MdArrowForwardIos /></ButtonNextPrev>
			</Col>

			<Col xs="2" style={{ padding: 0, margin: 3 }}>
				<InputYear
					disabled={disabledAll}
					selected={yearPlaceholder}
					onChange={handleYearChange}
					dateFormat="yyyy"
					showYearPicker
				/>
			</Col>


		</Row>


		{showAgenda &&
			<TableAgenda id="test-table-xls-button" responsive>
				<thead>
					<tr>
						<th className="day-label">D</th>
						<th className="day-label">S</th>
						<th className="day-label">T</th>
						<th className="day-label">Q</th>
						<th className="day-label">Q</th>
						<th className="day-label">S</th>
						<th className="day-label">S</th>
					</tr>
				</thead>
				<tbody>
					{renderDays()}
				</tbody>
			</TableAgenda>
		}
	</Container>
  );
}

export default Agenda;
